import { render, staticRenderFns } from "./Quizz.vue?vue&type=template&id=69ddcd92&"
import script from "./Quizz.vue?vue&type=script&lang=js&"
export * from "./Quizz.vue?vue&type=script&lang=js&"
import style0 from "./Quizz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports